__turbopack_context__.v({
  "icon": "socialIcons-module-scss-module__N4UhAW__icon",
  "socialIcons": "socialIcons-module-scss-module__N4UhAW__socialIcons",
  "title": "socialIcons-module-scss-module__N4UhAW__title",
});
